import { Vendor } from '../store/models/models';
import { DataProducerProject } from '../store/models/Project';

export const getDataContractName = (vendor: Vendor, project: DataProducerProject | undefined): string => {
  if (!vendor?.vendorName || !project?.name) {
    return '';
  }

  return `${vendor?.vendorName}-${project?.name}`;
};
